var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm._m(0);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "t-records",
    attrs: {
      "id": "allrecords",
      "data-tilda-export": "yes",
      "data-hook": "blocks-collection-content-node",
      "data-tilda-project-id": "1933100",
      "data-tilda-page-id": "14196891",
      "data-tilda-page-alias": "background",
      "data-tilda-formskey": "00da022453d7435b7731ad57b717c0d2"
    }
  }, [_c('div', {
    staticClass: "r t-rec",
    staticStyle: {},
    attrs: {
      "id": "rec234459542",
      "data-animationappear": "off",
      "data-record-type": "396"
    }
  }, [_c('div', {
    staticClass: "t396"
  }, [_c('div', {
    staticClass: "t396__artboard",
    attrs: {
      "data-artboard-recid": "234459542",
      "data-artboard-height": "720",
      "data-artboard-height-res-640": "720",
      "data-artboard-height-res-480": "560",
      "data-artboard-height-res-320": "560",
      "data-artboard-height_vh": "100",
      "data-artboard-height_vh-res-640": "100",
      "data-artboard-height_vh-res-320": "100",
      "data-artboard-valign": "center",
      "data-artboard-ovrflw": ""
    }
  }, [_c('div', {
    staticClass: "t396__carrier",
    attrs: {
      "data-artboard-recid": "234459542"
    }
  }), _c('div', {
    staticClass: "t396__filter",
    attrs: {
      "data-artboard-recid": "234459542"
    }
  }), _c('div', {
    staticClass: "t396__elem tn-elem tn-elem__2344595421601413302768 t-animate",
    attrs: {
      "data-elem-id": "1601413302768",
      "data-elem-type": "image",
      "data-field-top-value": "-57",
      "data-field-top-res-960-value": "-40",
      "data-field-top-res-640-value": "-59",
      "data-field-top-res-480-value": "-70",
      "data-field-top-res-320-value": "-55",
      "data-field-left-value": "17",
      "data-field-left-res-960-value": "18",
      "data-field-left-res-640-value": "63",
      "data-field-left-res-480-value": "1",
      "data-field-left-res-320-value": "2",
      "data-field-width-value": "70",
      "data-field-width-res-640-value": "124",
      "data-field-width-res-480-value": "137",
      "data-field-width-res-320-value": "158",
      "data-field-axisy-value": "top",
      "data-field-axisx-value": "right",
      "data-field-container-value": "window",
      "data-field-topunits-value": "%",
      "data-field-leftunits-value": "%",
      "data-field-heightunits-value": "",
      "data-field-widthunits-value": "%",
      "data-animate-style": "fadeinright",
      "data-animate-duration": "3",
      "data-animate-delay": "0.2",
      "data-animate-distance": "100",
      "data-animate-prx": "mouse",
      "data-animate-prx-dx": "10",
      "data-animate-prx-dy": "10",
      "data-animate-mobile": "y",
      "data-field-lazyoff-value": "y"
    }
  }, [_c('div', {
    staticClass: "tn-atom"
  }, [_c('img', {
    staticClass: "tn-atom__img",
    attrs: {
      "src": "/images/tilda/tild6265-6665-4136-b762-353562653762__ellipse.svg",
      "imgfield": "tn_img_1601413302768"
    }
  })])]), _c('div', {
    staticClass: "t396__elem tn-elem tn-elem__2344595421601413333763 t-animate",
    attrs: {
      "data-elem-id": "1601413333763",
      "data-elem-type": "image",
      "data-field-top-value": "49",
      "data-field-top-res-960-value": "31",
      "data-field-top-res-640-value": "38",
      "data-field-top-res-480-value": "71",
      "data-field-top-res-320-value": "43",
      "data-field-left-value": "-30",
      "data-field-left-res-960-value": "-23",
      "data-field-left-res-640-value": "-51",
      "data-field-left-res-480-value": "29",
      "data-field-left-res-320-value": "22",
      "data-field-width-value": "50",
      "data-field-width-res-960-value": "55",
      "data-field-width-res-640-value": "82",
      "data-field-width-res-480-value": "135",
      "data-field-width-res-320-value": "177",
      "data-field-axisy-value": "bottom",
      "data-field-axisx-value": "left",
      "data-field-container-value": "window",
      "data-field-topunits-value": "%",
      "data-field-leftunits-value": "%",
      "data-field-heightunits-value": "",
      "data-field-widthunits-value": "%",
      "data-animate-style": "fadeinleft",
      "data-animate-duration": "1",
      "data-animate-delay": "0.2",
      "data-animate-distance": "100",
      "data-animate-prx": "mouse",
      "data-animate-prx-dx": "40",
      "data-animate-prx-dy": "40",
      "data-animate-mobile": "y"
    }
  }, [_c('div', {
    staticClass: "tn-atom"
  }, [_c('img', {
    staticClass: "tn-atom__img t-img",
    attrs: {
      "data-original": "/images/tilda/tild6265-6665-4136-b762-353562653762__ellipse.svg",
      "imgfield": "tn_img_1601413333763"
    }
  })])])])])])]);
}]

export { render, staticRenderFns }